import { render } from "./ScrollTop.vue?vue&type=template&id=4cdc85c4"
import script from "./ScrollTop.vue?vue&type=script&lang=ts"
export * from "./ScrollTop.vue?vue&type=script&lang=ts"
script.render = render

export default script